//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '~/api/index';
export default {
  // props:['showSearch','display','netChange','turnVolume','volume'],
  data() {
    return {
      stockCode: null,
      stockList: [],
      showSearchFrame: false,
      isActive1: true, // 涨跌幅 涨/跌是否被选中
      isActive2: true, // 成交额 高/低是否被选中
      isActive3: true, // 成交量 高/低是否被选中
      netChange: [],
      turnVolume: [],
      volume: [],
    };
  },
  watch: {
    stockCode(val) {
      this.getStockList(val);
    },
  },
  mounted() {
    this.getNetChange();
    this.getTurnVolume();
    this.getVolume();
  },
  methods: {
    async getNetChange() {
      const netChange = await this.$axios(
        api.getMarketRange({
          sort: 'netChange',
          order: 'desc',
        })
      );
      this.netChange = netChange.result;
    },
    async getTurnVolume() {
      const turnVolume = await this.$axios(
        api.getMarketRange({
          sort: 'turnVolume',
          order: 'desc',
        })
      );
      this.turnVolume = turnVolume.result;
    },
    async getVolume() {
      const volume = await this.$axios(
        api.getMarketRange({
          sort: 'volume',
          order: 'desc',
        })
      );
      this.volume = volume.result;
    },
    clickEvt(type, code) {
      const routeUrl = this.$router.resolve({
        path: `/stock/${type.toLowerCase() + code}`,
      });
      window.open(routeUrl.href, '_blank');
    },
    clickRowJump(type, code) {
      const routeUrl = this.$router.resolve({
        path: `/stock/${type.toLowerCase() + code}`,
      });
      window.open(routeUrl.href, '_blank');
    },
    async getHighData(type, sort) {
      const highData = await this.$axios(
        api.getMarketRange({
          sort: type,
          order: sort,
        })
      );
      if (type === 'netChange') {
        this.netChange = highData.result;
        this.isActive1 = true;
      } else if (type === 'turnVolume') {
        this.turnVolume = highData.result;
        this.isActive2 = true;
      } else if (type === 'volume') {
        this.volume = highData.result;
        this.isActive3 = true;
      }
    },
    async getLowData(type, sort) {
      const lowData = await this.$axios(
        api.getMarketRange({
          sort: type,
          order: sort,
        })
      );
      if (type === 'netChange') {
        this.netChange = lowData.result;
        this.isActive1 = false;
      } else if (type === 'turnVolume') {
        this.turnVolume = lowData.result;
        this.isActive2 = false;
      } else if (type === 'volume') {
        this.volume = lowData.result;
        this.isActive3 = false;
      }
    },
    getStockList(val) {
      if (val) {
        this.showSearchFrame = true;
        this.$axios(
          api.getStockList({
            stockCodes: val,
          })
        )
          .then(res => {
            const temp = res.result.stockList;
            this.stockList = temp.splice(0, 5);
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.log(err);
          });
      } else {
        this.showSearchFrame = false;
      }
    },
    handleBlur() {
      setTimeout(() => {
        this.showSearchFrame = false;
      }, 300);
    },
  },
};
